import React from "react";
import { withRouter, RouteComponentProps } from "react-router";
import { connect } from "react-redux";
import { compose } from "redux";
import { createStructuredSelector } from "reselect";
import NewPage from "../../../pages/Search/New/NewPage.page";
import {
  fetchResults,
  SEARCH_DATA,
  clearLoads,
  getCountryStateCodes,
  updateDateOffset,
} from "../../../../actions/Search/action";
import useInjectSaga from "../../../../utils/injectSaga";
import saga from "../../../../saga/Search/Search.saga";
import recentSaga from "../../../../saga/Recent/saga";
import {
  getLoading,
  getUserData,
  getNetworkStatus,
  getUserMasterData,
} from "../../../../selectors/selector";
import {
  makeSearch,
  countryStateCodesSelector,
  getOffSet,
} from "../../../../selectors/Search/selector";

import useInjectReducer from "../../../../utils/injectReducer";
import reducer from "../../../../reducers/Search/reducer";
import {
  ILoadSearchResults,
  CountryCodes as CountryCodesSchema,
} from "../../../../schemas/Search/Search.schema";
import { DomainConverter } from "../../../../utils/common";
import { SearchResults } from "../../../../models/home/SearchResults.model";

import { showAlert } from "../../../../actions/App/action";
import { getUpdatedId } from '../../../../selectors/FavouriteSearch/selector';
import { favoriteError } from '../../../../selectors/RecentSearch/selector';
import { updateFavoriteData } from '../../../../actions/Favorite/action';
import { clearFavoriteError } from '../../../../actions/Recent/action';
import { IUserDetails } from "../../../../schemas/user";

const key = "search";
export interface NewProps extends RouteComponentProps {
  history: any;
  searchData: any;
  data: any;
  loading: any;
  location: any;
  fetchData: any;
  clearLoads: any;
  userData: any;
  isRecentSearch: boolean;
  userDetails: IUserDetails;
  isNetworkAvailable: boolean;
  showAlert: any;
  searchParams: any;
  doScroll: any;
  getCountryStateCodes: any;
  countryStateCodes: CountryCodesSchema[];
  getOffSet: any;
  updateFavoriteLoads:any;
  getUpdatedId: any;
  errorData: any;
  clearErrorState: any;
  updateDateOffset?: (data: {originDateDefaultOffset: string,destinationDateDefaultOffset:string}) => void
}
export const NewContainer: React.FC<NewProps> = ({
  location,
  fetchData,
  data,
  clearLoads,
  isRecentSearch,
  userDetails,
  isNetworkAvailable,
  showAlert,
  doScroll,
  getCountryStateCodes,
  countryStateCodes,
  getOffSet,
  updateFavoriteLoads,
  getUpdatedId,
  errorData,
  clearErrorState,
  updateDateOffset
}) => {
  return (
    <NewPage
      isRecentSearch={isRecentSearch}
      data={location.state ? location.state.params : {}}
      submitForm={(searchdata: any) => {
        clearLoads();
        fetchData(searchdata.getRequestPayload(), false, false, () =>
          doScroll(750)
        );
      }}
      results={DomainConverter.dataToDomain<ILoadSearchResults>(
        SearchResults,
        data
      )}
      userDetails={userDetails}
      totalRecords={data.totalRecords}
      isNetworkAvailable={isNetworkAvailable}
      showAlert={showAlert}
      getCountryStateCodes={getCountryStateCodes}
      countryStateCodes={countryStateCodes}
      getOffSet={getOffSet}
      updateFavoriteLoads={updateFavoriteLoads}
      getUpdatedId = {getUpdatedId}
      errorData = {errorData}
      clearErrorState = {clearErrorState}
      updateDateOffset={updateDateOffset}
    />
  );
};

const mapStateToProps = createStructuredSelector({
  loading: getLoading(),
  data: makeSearch(),
  userData: getUserData(),
  userDetails: getUserMasterData(),
  isNetworkAvailable: getNetworkStatus(),
  countryStateCodes: countryStateCodesSelector(),
  getOffSet: getOffSet(),
  getUpdatedId: getUpdatedId(),
  errorData: favoriteError(),
});

export const mapDispatchToProps = (dispatch: any) => ({
  fetchData: (
    searchdata: any,
    isPagination: boolean,
    isHideLoader = false,
    callback?: any
  ) => dispatch(fetchResults(searchdata, isPagination, isHideLoader, callback)),
  searchData: (data: any) => dispatch(SEARCH_DATA(data)),
  clearLoads: () => dispatch(clearLoads()),
  showAlert: (data: any) => dispatch(showAlert(data)),
  getCountryStateCodes: () => dispatch(getCountryStateCodes()),
  updateFavoriteLoads: (favoriteSearch: any, isHideLoader: boolean) =>
  dispatch(updateFavoriteData(favoriteSearch, isHideLoader)),
  clearErrorState: () => dispatch(clearFavoriteError()),
  updateDateOffset: (data:any)=> dispatch(updateDateOffset(data))
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withReducer = useInjectReducer({ key, reducer });
const withSaga = useInjectSaga({ key, saga });
const withRecentSaga = useInjectSaga({ key:"recent", saga:recentSaga });
export default compose<any>(
  withSaga,
  withRecentSaga,
  withReducer,
  withConnect
)(withRouter(React.memo(NewContainer)));
